import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { staticMiddleEllipsis } from '../../utils/ellipsisHelpers.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as Body } from '../Body/Body.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded = ["leftSideLength", "rightSideLength", "text", "rc", "sx"],
  _excluded2 = ["use"],
  _excluded3 = ["size"],
  _excluded4 = ["weight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function EllipsizedText(_ref) {
  var _ref$leftSideLength = _ref.leftSideLength,
    leftSideLength = _ref$leftSideLength === void 0 ? 8 : _ref$leftSideLength,
    _ref$rightSideLength = _ref.rightSideLength,
    rightSideLength = _ref$rightSideLength === void 0 ? 4 : _ref$rightSideLength,
    text = _ref.text,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = "use" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      use: undefined
    }),
    use = _ref2.use,
    propsMinusUse = _objectWithoutProperties(_ref2, _excluded2);
  var _ref3 = "size" in propsMinusUse ? propsMinusUse : _objectSpread({
      size: undefined
    }, propsMinusUse),
    size = _ref3.size,
    propsMinusUseAndSize = _objectWithoutProperties(_ref3, _excluded3);
  var _ref4 = "weight" in propsMinusUseAndSize ? propsMinusUseAndSize : _objectSpread({
      weight: undefined
    }, propsMinusUseAndSize),
    weight = _ref4.weight,
    propsMinusUseSizeAndWeight = _objectWithoutProperties(_ref4, _excluded4);
  var content = staticMiddleEllipsis({
    leftSideLength: leftSideLength,
    rightSideLength: rightSideLength,
    text: text
  });
  return cloneElementWithCssProp(use || jsx(Body, {
    size: size,
    weight: weight
  }), _objectSpread(_objectSpread({}, propsMinusUseSizeAndWeight), {}, {
    rc: rc,
    sx: sx,
    children: content
  }));
}
EllipsizedText.displayName = "EllipsizedText";

export { EllipsizedText as E };
//# sourceMappingURL=EllipsizedText.js.map
